/**
 * External dependencies
 */
import {  remove, get } from 'lodash';

/**
 * Internal dependencies
 */
import { editReport } from 'state/reports/actions';
import { getEditedReport } from 'state/reports/selectors';
import { getBuilderReportId } from 'state/ui/report-builder/selectors';

export default (measure) => (dispatch, getState) => {
	let state = getState();
	let reportId = getBuilderReportId(state);
	let report = getEditedReport(state, reportId);

	if (!report) {
		return false;
	}

	let measures = get(report, 'config.measures', []);

	measures = remove([...measures], (m) => m !== measure);

	dispatch(editReport(reportId, { config: { measures } }));
};
